import cn from 'classnames'
import { HTMLAttributes } from 'react'

import { Tooltip } from 'core-components/library/tooltip'

import styles from './HPOrgRankIcon.module.scss'

type Props = HTMLAttributes<HTMLSpanElement> & {
  hpOrgRank?: string | null
}

const RANK_CONFIG: Record<string, { icon: string; text: string; size: string }> = {
  Top_50: { icon: '50', text: 'Top 50', size: '1rem' },
  Top_100: { icon: '100', text: 'Top 100', size: '1rem' },
  Top_150: { icon: '150', text: 'Top 150', size: '1rem' },
  Top_200: { icon: '200', text: 'Top 200', size: '1rem' },
  Top_250: { icon: '250', text: 'Top 250', size: '1rem' },
  Top_500: { icon: '500', text: 'Top 500', size: '1rem' },
  Top_1000: { icon: '1000', text: 'Top 1000', size: '0.7rem' },
  over_Top_1000: { icon: '>1000', text: 'Over Top 1000', size: '0.5rem' },
}

export const HPOrgRankIcon = ({ hpOrgRank, className, ...props }: Props) => {
  const config = hpOrgRank ? RANK_CONFIG[hpOrgRank] : undefined

  if (!config) {
    return null
  }
  return (
    <Tooltip tipContent={() => <>{config.text}</>}>
      <span {...props} className={cn(styles.icon, className)} style={{ fontSize: config.size }}>
        {config.icon}
      </span>
    </Tooltip>
  )
}
